import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-scheduling-tab-2-part',
	standalone: true,
	templateUrl: './experience-scheduling-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-scheduling-tab-2.part.scss`],
})
export class ExperienceSchedulingTab2Part {
}
